// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3wcPC","productName":"Table_productName__3OL_3"};